import { useRef, useState } from "react";

export const useSaveStatus = () => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [savedFlash, setSavedFlash] = useState(false);
  const timer = useRef(null);

  const flash = () => {
    setSavedFlash(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setSavedFlash(false), 2500);
  };

  return { saving, setSaving, error, setError, savedFlash, flash };
};
